import getCountryFromUrl from './getCountryFromUrl';
import { WHITELISTED_COUNTRIES } from '../config/settings';

const isConsentRelevant = () => {
    const countryCode = getCountryFromUrl();
    return WHITELISTED_COUNTRIES.includes(countryCode);
};

export default isConsentRelevant;
